var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGratitudeJournaling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 148,
    viewBox: "0 0 281 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 110C77.6995 110 58 90.3005 58 66C58 41.6995 77.6995 22 102 22C126.301 22 146 41.6995 146 66C146 90.3005 126.301 110 102 110Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 148C93.4903 148 72 126.51 72 100C72 73.4903 93.4903 52 120 52C146.51 52 168 73.4903 168 100C168 126.51 146.51 148 120 148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169 78C149.118 78 133 61.8823 133 42C133 22.1177 149.118 6 169 6C188.882 6 205 22.1177 205 42C205 61.8823 188.882 78 169 78Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176 124C149.49 124 128 102.51 128 76C128 49.4903 149.49 28 176 28C202.51 28 224 49.4903 224 76C224 102.51 202.51 124 176 124Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132 88C107.699 88 88 68.3005 88 44C88 19.6995 107.699 0 132 0C156.301 0 176 19.6995 176 44C176 68.3005 156.301 88 132 88Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163 148C140.909 148 123 130.091 123 108C123 85.9086 140.909 68 163 68C185.091 68 203 85.9086 203 108C203 130.091 185.091 148 163 148Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 224 0)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 66 134)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 55)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 64 6)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 266 100)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 281 44)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146 22C117.281 22 94 45.2812 94 74C94 88.3594 99.8203 101.359 109.23 110.77L95.7071 124.293C95.0771 124.923 95.5233 126 96.4142 126H145C145.041 126 145.081 125.998 145.121 125.993C145.414 125.998 145.707 126 146 126C174.719 126 198 102.719 198 74C198 45.2812 174.719 22 146 22Z",
    fill: "#F13F5F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.614 51.517C150.209 52.2701 147.954 53.7761 146 55.5834C143.895 53.7761 141.791 52.2701 139.386 51.517C130.516 48.8061 123 57.2401 123 65.5234C123 81.1864 142.693 97 146 97C149.307 97 169 81.337 169 65.5234C169 57.2401 161.183 48.8061 152.614 51.517Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.5L38 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228 28.5L247 22",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M224 121.5L244.5 127",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 106.5L26 117",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGratitudeJournaling);
export default __webpack_public_path__ + "static/media/gratitude-journaling.150640aca0c41c91dfd371f67b6b2789.svg";
export { ForwardRef as ReactComponent };